import React, { useEffect, useState } from 'react';
import { Modal, Button, Form, Input, InputNumber } from 'antd';
import api from '../../apis';
import { privateDecrypt } from 'crypto';
import {  showSuccessMessageModal } from '../../components/utils';


const EditUnrealizePriceMdal = ({
    children,
    data,
    aid,
    tid,
    onClose
}:any) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [_aid, set_aid] = useState(null);
  const [_tid, set_id] = useState(null);

    useEffect(() => {
        setInitialValues(data);

        set_aid(aid);
        set_id(tid);
    }, []);

  // Function to show the modal
  const showModal = () => {
    setIsModalVisible(true);
  };

  // Function to hide the modal
  const handleOk = () => {
    setIsModalVisible(false);
  };

  // Function to hide the modal on cancel
  const handleCancel = () => {
    setIsModalVisible(false);
    onClose();
  };

  const onFinish = (values: any) => {
  //  console.log('Received values:', values);
    requestData(values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  const requestData = async (values) =>{

   let result = await api.updatePortfolioUnrealizedHistoryPrice(_aid,initialValues.orderno, {
    price:values.price
   });
  
   if(result.status == 0) {
     // alert("Update Successful");
      showSuccessMessageModal("Update Successful");
  }

  handleCancel();
   //console.log("updatePortfolioUnrealizedHistoryPrice ",typeof result)
}

  return (
    <div>

      <span onClick={showModal}  >
        <u className='cursor-pointer'>
        {
            children
        }

        </u>
      </span>

      <Modal
        title="Edit Price"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        maskClosable={false}
      >
         <Form
            name="priceForm"
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            initialValues={initialValues}
            >


            <Form.Item
                label="Price"
                name="price"
                rules={[{ required: true, message: 'Please enter the price!' }]}
            >
                <InputNumber
                    // prefix="$"
                    style={{ width: '100%' }}
                    min={0}
                    step={0.01}
               
                />
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit" className='btn-primary-custom btn-md'>
                Submit
                </Button>
            </Form.Item>
            </Form>
      </Modal>
    </div>
  );
};

export default EditUnrealizePriceMdal;